export default __webpack_public_path__ + "static/media/information--camera--g1.a402e59a.png";